export enum IVCalculationPrice {
    Ask,
    Bid,
    BidAsk,
    Last
}
